import ListView from "./ListView/ListView";

const HistoryRamp = () => <p>HistoryRamp</p>;

HistoryRamp.ListView = ListView;
export default HistoryRamp;
